import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateInfo } from "../../services/loginInfo";
import { getAccessToken } from "./authUtils";

/**
 * Hydrates Redux user info from the JWT when the store is empty on first load.
 * Only runs when a token exists — otherwise updateInfo returns {} and would
 * re-trigger forever because empty object keys never change.
 */
export function useAuthBootstrap() {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userInfo);
  const hasBootstrapped = useRef(false);

  useEffect(() => {
    const token = getAccessToken();

    if (!token || hasBootstrapped.current) {
      return;
    }

    if (userData.data && Object.keys(userData.data).length === 0) {
      hasBootstrapped.current = true;
      dispatch(updateInfo());
    }
  }, [dispatch, userData.data]);
}
